import React from 'react'
import {
  Button, WhiteSpace, Toast
} from 'antd-mobile';
import Header from '../../components/Header'
// import './special.less'
import { getSpecial } from '../../api/activity'
import { storyDetail } from '../../api/stories'
import palyBtn from '../../images/icon@2x.png'
import palyImg from '../../images/special_play.png'
import { getQueryString, jumpApp, urlJump, isWeChat, openMiniProgramPage, whichSystem } from '../../utils/utils'
import wx from 'weixin-js-sdk'
import back from "../../images/back2.png";
import { SpecialStyle } from './specialComp';


export default class ActivitySpecial extends React.Component {
  state = {
    id: this.props.match.params.id,
    specials: [],
    available: getQueryString('os_version') ? getQueryString('os_version').replace('.', '') > 53.1 : false
  }

  componentDidMount() {
    this.requestList()
    // if (isWeChat() == 3 || isWeChat() == 4) {
    //   if (!this.state.available) {
    //     Toast.info('请升级最新版本才能收听');
    //   }
    // }
  }

  requestList = () => {
    getSpecial({ id: this.state.id })
      .then((res) => {
        this.setState({
          specials: res
        })
      })
  }


  //跳转到app专辑页
  goAppTheme = (id) => {
    // if (isWeChat() == 3 || isWeChat() == 4) {
    //   if (!this.state.available) {
    //     Toast.info('请升级最新版本才能收听');
    //     return;
    //   }
    //   jumpApp({
    //     opentype: 'theme', openvar: id, isvideo: 0
    //   })
    // } else {
    //   let url = openMiniProgramPage({ opentype: 'theme', openvar: id, isvideo: 0 })
    //   wx.miniProgram.navigateTo({
    //     url: url
    //   })
    // }

    if (isWeChat() == 5) {
      let url = openMiniProgramPage({ opentype: 'theme', openvar: id, isvideo: 0 })
      wx.miniProgram.navigateTo({
        url: url
      })
    } else {
      // if (!this.state.available) {
      //   Toast.info('请升级最新版本才能收听');
      //   return;
      // }
      jumpApp({
        opentype: 'theme', openvar: id, isvideo: 0
      })
    }
  }

  //跳转到app故事页
  goAppStory = (id) => {
    if (isWeChat() == 3 || isWeChat() == 4) {
      // if (!this.state.available) {
      //   Toast.info('请升级最新版本才能收听');
      //   return;
      // }
      jumpApp({ opentype: 'story', openvar: id, isvideo: 0 })
    } else {
      storyDetail({ story_id: id })
        .then((res) => {
          openMiniProgramPage({ opentype: 'story', openvar: id, isvideo: 0, cate_id: res.cate_id })
        })
    }
  }



  //广告位 跳转app
  adJumpApp = () => {
    let special = this.state.specials.length > 0 ? this.state.specials[0] : {}
    if (isWeChat() == 3 || isWeChat() == 4) {
      // if (!this.state.available) {
      //   Toast.info('请升级最新版本才能收听');
      //   return;
      // }
      jumpApp({ opentype: special.opentype, openvar: special.openvar, isvideo: 0 })
    } else {
      if (special.opentype == 'story' && special.openvar > 0) {
        storyDetail({ story_id: special.openvar })
          .then((res) => {
            openMiniProgramPage({ opentype: special.opentype, openvar: special.openvar, isvideo: 0, cate_id: res.cate_id })
          })
      } else {
        openMiniProgramPage({ opentype: special.opentype, openvar: special.openvar, isvideo: 0 })
      }
    }
  }

  goSpecial = (id) => {
    // if (!this.state.available) {
    //   Toast.info('请升级最新版本才能收听');
    //   return;
    // }
    urlJump("/activity/special/" + id + '?os_version=' + getQueryString('os_version'))
  }



  render() {
    const bkStyle = {
      //background: url("${special.backgroundimage}") 0% 0% / contain;

      background: 'url(${special.backgroundimage})',
      backgroundSize: "contain"
    }
    const { specials } = this.state
    let special = specials.length > 0 ? specials[0] : {}

    return (<SpecialStyle>
      <div className="full">
        <div className="special" style={{ background: `${special.backgroundcolor} url(${special.backgroundimage}) repeat-y 100%/100%` }} >
          {/* <Header name="专题" rightContent="" /> */}
          <section className="special-container">
            <div className="banner">

              <img src={special.cover} alt="" />
            </div>
            <div className="intro-title"> <h4 style={{ color: special.textcolor }}>{special.title}</h4></div>

            <div className="intro" dangerouslySetInnerHTML={{ __html: special.intro }} style={{ color: special.textcolor }}></div>
            <div className="cate-container" >
              {
                special.cates && special.cates.length > 0 ?
                  special.cates.map((item, i) => (
                    // <div className="item" key={i} onClick={() => { this.goAppTheme(item.id) }} style={{ borderBottomColor: special.textcolor }} >
                    <div className="cate-item" key={i}>
                      <div className="item" onClick={() => { this.goAppTheme(item.id) }} >
                        <div className="left">
                          <img src={item.image} alt="" />
                        </div>
                        <div className="right">
                          <div className="title" style={{ color: special.textcolor }}>{item.name}</div>
                          <div className="explain" style={{ color: special.textcolor }}>{item.introduction}</div>
                          <div className="playbtn" style={{ backgroundColor: special.playbtncolor, color: special.textcolor }}> <img src={palyBtn} className="" alt="" />  播放</div>
                        </div>
                      </div>
                      <div className="item-bottom-border" style={{ backgroundColor: special.textcolor }}></div>
                    </div>

                  )) : ''
              }
            </div>

            {
              special.banner ?
                <div className="ad-banner" onClick={this.adJumpApp}>
                  <img src={special.banner} alt="" />
                </div> : ''
            }


            <div className="story-container">
              {
                special.stories && special.stories.length > 0 ?
                  special.stories.map((item, i) => (
                    <div className="story-item" key={i} >
                      <div className="item" onClick={() => { this.goAppStory(item.id) }}>
                        <div className="left">
                          <img src={item.image} alt="" />
                        </div>
                        <div className="right">
                          <div className="title" style={{ color: special.textcolor }}>{item.title}</div>
                          <div className="explain" style={{ color: special.textcolor }}>{item.introduction}</div>
                          <div className="playbtn" style={{ backgroundColor: special.playbtncolor, color: special.textcolor }}> <img src={palyBtn} className="" alt="" />  播放</div>
                        </div>
                        {/*<div className="play">*/}
                        {/*  <img src={palyImg} alt="" />*/}
                        {/*</div>*/}
                      </div>
                      <div className="item-bottom-border" style={{ backgroundColor: special.textcolor }}></div>
                    </div>
                  )) : ''
              }
            </div>
            {/*{*/}
            {/*    specials.length > 1 ?*/}
            {/*    <div className="past-past">*/}
            {/*      <p className="title">往期专题</p><WhiteSpace size="xl" />*/}
            {/*      {*/}
            {/*        specials.length > 1 ?*/}
            {/*        specials.map((item, i) => (*/}
            {/*          i > 0 ? <div key={i}><Button className={"button" + i} onClick={()=>{this.goSpecial(item.id)}}>{item.title}</Button> <WhiteSpace size="md" /></div> : ''*/}
            {/*        )) : ''*/}
            {/*      }*/}
            {/*    </div> : ''*/}
            {/*}*/}
          </section>
        </div>
      </div>
    </SpecialStyle>

    )
  }
}